import type React from 'react';
import channelLogisticsLogo from '@/assets/icons/channel-logistics-logo.png';
import emailIcon from '@/assets/icons/email.png';
import { ActionButton } from '@/components/atoms/primitives';
import type { ForgotPasswordStageProps } from './ForgotPasswordStage.types';

export const ForgotPasswordStage: React.FC<ForgotPasswordStageProps> = ({ onSubmit, onReturn }) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const target = event.target as typeof event.target & {
      email: { value: string };
    };
    onSubmit(target.email.value);
  };

  return (
    <div className="flex flex-col items-center justify-center min-w-[600px] max-w-[600px] flex-shrink-0 h-full overflow-hidden relative">
      <div
        className="absolute right-4 bottom-4 w-[100px] h-[70px] bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${channelLogisticsLogo})` }}
      />
      <form className="flex flex-col w-[400px] h-[500px] overflow-y-auto" onSubmit={handleSubmit}>
        <h1 className="text-2xl text-white font-bold mb-8">Forgot password</h1>
        <label htmlFor="forgot-password-email" className="text-base text-white font-bold mb-2.5 block">
          Email address
        </label>
        <div className="flex items-center max-w-full h-[50px] border border-gray-500 rounded-2xl px-4 mb-6">
          <span
            className="w-6 h-6 bg-cover filter invert-[90%]"
            style={{ backgroundImage: `url(${emailIcon})` }}
            aria-hidden="true"
          />
          <input
            id="forgot-password-email"
            name="email"
            type="email"
            className="w-[300px] ml-4 bg-transparent border-none text-white focus:outline-none"
            placeholder="test@email.com"
            required
            autoComplete="email"
          />
        </div>
        <ActionButton variant="primary" onClick={() => {}} className="w-full text-center align-center">
          Continue
        </ActionButton>
        <p className="text-white mt-4 text-center">
          <ActionButton variant="back" onClick={onReturn} className="w-full text-center align-center">
            Return
          </ActionButton>
        </p>
      </form>
    </div>
  );
};
